import type { ReactElement } from 'react';
import { Button } from './button.jsx';
import type { NextProps } from './types.js';

/** Footer `<Next>` button. */
export const Next = ({ label = 'Continue', ...props }: NextProps): ReactElement => (
  <Button label={label} variant='primary' {...props} />
);
